//const BASE_URL = "https://us-central1-united-coil-363723.cloudfunctions.net";
const BASE_URL = "https://us-central1-grading-b1723.cloudfunctions.net";

async function get_Data() {
  return await fetch(`${BASE_URL}${process.env.REACT_APP_GET_DATA}`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET",
      "Access-Control-Allow-Headers": "Content-Type"
    },
  })
    .then(response => response.json())
    .then((data) => {
      data.forEach((i, index) => {
        data[index].id = index + 1;
      });
      return data;
    });
}

async function save_Payment(data){
  return await fetch(`${BASE_URL}${process.env.REACT_APP_SAVE_PAYMENT}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Content-Type"
      },
      body: JSON.stringify(data)
    }).then((response) => {
      if (response.status === 200) {
        return true;
      }
    })
      .catch((error) => {
        console.error('Error:', error);
        return false
      });
}

async function get_Coupon(coupon){
    return await fetch(`${BASE_URL}${process.env.REACT_APP_GET_COUPON}`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
          "Access-Control-Allow-Headers": "Content-Type"
        },
        body: JSON.stringify({
            coupon: coupon
        })
      })
        .then(response => response.json())
        .then((data) => {
          return data;
        });
}

export default {
    get_Data,
    save_Payment,
    get_Coupon
};